import React from 'react';
import { Sparkles, Clock, MessageCircleOff } from 'lucide-react';
export function Solution() {
  return <section className="py-12 md:py-16 relative overflow-hidden" data-id="element-175">
      {/* Background Accent */}
      <div className="absolute right-0 top-1/4 w-1/3 h-1/2 bg-amber-900/10 blur-[100px] rounded-full pointer-events-none" data-id="element-176" />

      <div className="container mx-auto px-4 max-w-5xl" data-id="element-177">
        <div className="text-center mb-16" data-id="element-178">
          <span className="text-amber-400 font-medium tracking-widest text-sm uppercase mb-2 block" data-id="element-179">
            La Solución
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-cream-100 mb-6" data-id="element-180">
            Anti-Roomies: El Reset de 14 Días
          </h2>
          <p className="text-xl text-cream-200/80 max-w-2xl mx-auto" data-id="element-181">
            No necesitas una conversación gigante. Necesitas{' '}
            <span className="text-amber-300 font-medium" data-id="element-182">
              estructura pequeña
            </span>
            . Un sistema tan simple que una pareja agotada lo pueda sostener.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-183">
          {[{
          icon: Clock,
          title: 'Ritual 2x7',
          desc: '2 micro-momentos diarios de 7–10 min (sin pantallas) para reconectar sin presión.'
        }, {
          icon: Sparkles,
          title: 'Sistema de Bids',
          desc: 'Aprende a pedir y recibir conexión sin rogar, sin indirectas y sin pelear.'
        }, {
          icon: MessageCircleOff,
          title: 'Regla No-Discusión',
          desc: "14 días sin 'la charla eterna'. Prohibido intentar arreglar todo de golpe."
        }].map((item, i) => <div key={i} className="group p-6 rounded-xl bg-charcoal-700/30 border border-charcoal-600 hover:border-amber-400/30 transition-all duration-300 hover:bg-charcoal-700/50" data-id="element-184">
              <div className="w-12 h-12 rounded-full bg-amber-400/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-185">
                <item.icon className="w-6 h-6 text-amber-400" data-id="element-186" />
              </div>
              <h3 className="text-xl font-serif text-cream-100 mb-3" data-id="element-187">
                {item.title}
              </h3>
              <p className="text-cream-200/70 leading-relaxed" data-id="element-188">{item.desc}</p>
            </div>)}
        </div>

        <div className="mt-16 p-8 md:p-12 bg-gradient-to-br from-amber-900/20 to-charcoal-800 rounded-2xl border border-amber-500/10 text-center" data-id="element-189">
          <h3 className="text-2xl font-serif text-amber-200 mb-4" data-id="element-190">
            La idea que cambia todo
          </h3>
          <p className="text-lg md:text-xl text-cream-100 italic max-w-3xl mx-auto leading-relaxed" data-id="element-191">
            "La chispa no vuelve por presión. Vuelve por seguridad. Primero se
            repara el clima. Luego aparece la cercanía. Después, la intimidad
            deja de sentirse rara."
          </p>
        </div>
      </div>
    </section>;
}